export default function PlainTextViewer({ value }) {
  if (!value) return null;

  return (
    <div
      className="prose prose-sm text-gray-800"
      dangerouslySetInnerHTML={{ __html: value }}
    />
  );
}
